"use client";

import { useContext, useState } from "react";
import { MailIcon } from "lucide-react";
import { UserContext } from "@/contexts/user-context";
import { NewsletterSwitch } from "@/components/common/newsletter-switch";

export const NewsletterBanner = () => {
  const { isLoggedIn, marketing } = useContext(UserContext);
  const { newsletter } = marketing ?? {};
  const { tags } = newsletter ?? {};
  const isSubscribed = tags?.includes("klub-medyka");
  const [hidden, setHidden] = useState(false);

  if (!isLoggedIn || isSubscribed || hidden) {
    return null;
  }

  return (
    <div className="relative mt-6 mb-6 overflow-hidden rounded-[20px] border border-zinc-800 bg-[linear-gradient(135deg,#0f172a_0%,#1e1b4b_55%,#312e81_100%)] px-6 py-6 md:px-8">
      <div
        className="pointer-events-none absolute -top-12 -right-12 h-48 w-48 rounded-full bg-[radial-gradient(circle,rgba(132,204,22,0.18)_0%,transparent_70%)]"
        aria-hidden="true"
      />

      <div className="relative flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lime-400/15 ring-1 ring-lime-300/30">
            <MailIcon className="h-5 w-5 text-lime-300" />
          </div>
          <div>
            <p className="text-[15px] font-bold tracking-tight text-white md:text-base">
              Newsletter Klubu Medyka
            </p>
            <p className="mt-0.5 text-[13px] leading-snug text-zinc-300">
              Bądź pierwszy przy nowych zniżkach i ofertach dla medyków.
            </p>
          </div>
        </div>

        <div className="shrink-0">
          <NewsletterSwitch isButton setHide={() => setHidden(true)} />
        </div>
      </div>
    </div>
  );
};
